




















import { Component, Prop, Vue } from "vue-property-decorator";
import { PlayersType, PlayerInputsType, PlayerInfoNumberType, PlayerInfoStringType } from "@/types";
import PlayerTag, { TagSizeType } from "@/components/game/PlayerTag.vue";
import { pluralize } from "@/app/helpers";

@Component({ components: { PlayerTag } })
export default class PlayerList extends Vue {
  @Prop({ required: false }) hiddenIds?: string[];
  @Prop({ required: true }) playerIds!: string[];
  @Prop({ required: false }) extras?:
    | PlayerInputsType
    | PlayerInfoNumberType
    | PlayerInfoStringType;
  @Prop({ required: false }) extraWord?: string;
  @Prop({ required: false }) onClick?: (id: string) => void;
  @Prop({ required: true }) playerId!: string;
  @Prop({ required: true }) players!: PlayersType;
  @Prop({ required: false, default: "normal" }) size!: TagSizeType;

  extra(playerId: string) {
    if (!this.extras) return undefined;
    const extra = this.extras[playerId];
    const val = typeof extra === "object" ? extra.value : extra;
    const word = this.extraWord ? ` ${pluralize(this.extraWord, parseInt(val as string))}` : "";
    return `${val}${word}`;
  }
  hidden(id: string) {
    return (this.hiddenIds || []).includes(id);
  }

  get playersArray() {
    return this.playerIds
      .map((id) => this.players[id])
      .filter((a) => !!a && !this.hidden(a.id) && a.id !== this.playerId);
  }
}
